<div class="wrapper">
  @if (data.type === 'success') {
  <div>
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 2.75C8.91 2.75 2.75 8.91 2.75 16.5C2.75 24.09 8.91 30.25 16.5 30.25C24.09 30.25 30.25 24.09 30.25 16.5C30.25 8.91 24.09 2.75 16.5 2.75ZM16.5 27.5C10.4363 27.5 5.5 22.5637 5.5 16.5C5.5 10.4363 10.4363 5.5 16.5 5.5C22.5637 5.5 27.5 10.4363 27.5 16.5C27.5 22.5637 22.5637 27.5 16.5 27.5ZM22.8113 10.4225L13.75 19.4837L10.1887 15.9363L8.25 17.875L13.75 23.375L24.75 12.375L22.8113 10.4225Z"
        fill="#157378"
      />
    </svg>
  </div>
  } @if (data.type === 'fail') {
  <div>
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.125 20.625H17.875V23.375H15.125V20.625ZM15.125 9.625H17.875V17.875H15.125V9.625ZM16.5 2.75C8.89625 2.75 2.75 8.9375 2.75 16.5C2.75 20.1467 4.19866 23.6441 6.77728 26.2227C8.05409 27.4995 9.56988 28.5123 11.2381 29.2033C12.9063 29.8943 14.6943 30.25 16.5 30.25C20.1467 30.25 23.6441 28.8013 26.2227 26.2227C28.8013 23.6441 30.25 20.1467 30.25 16.5C30.25 14.6943 29.8943 12.9063 29.2033 11.2381C28.5123 9.56988 27.4995 8.05409 26.2227 6.77728C24.9459 5.50048 23.4301 4.48766 21.7619 3.79666C20.0937 3.10565 18.3057 2.75 16.5 2.75ZM16.5 27.5C13.5826 27.5 10.7847 26.3411 8.72183 24.2782C6.65893 22.2153 5.5 19.4174 5.5 16.5C5.5 13.5826 6.65893 10.7847 8.72183 8.72183C10.7847 6.65893 13.5826 5.5 16.5 5.5C19.4174 5.5 22.2153 6.65893 24.2782 8.72183C26.3411 10.7847 27.5 13.5826 27.5 16.5C27.5 19.4174 26.3411 22.2153 24.2782 24.2782C22.2153 26.3411 19.4174 27.5 16.5 27.5Z"
        fill="#CE4B4B"
      />
    </svg>
  </div>
  }
  <div>
    <span class="" matSnackBarLabel [innerHTML]="data.message"></span>
  </div>
  <div>
    <firebird-web-icon
      name="cross"
      width="15px"
      height="15px"
      (click)="close()"
    ></firebird-web-icon>
  </div>
</div>
